export enum SocialInteractions {
    LIKE = '👍',
    LOVE = '❤️',
    CARE = '🥰',
    HAHA = '😂',
    WOW = '😮',
    SAD = '😞',
    CRY = '😢',
    ANGRY = '😡',
    THUMBS_UP = '👍',
    THUMBS_DOWN = '👎',
    SMILE = '😊',
    GRIN = '😁',
    LAUGH = '😄',
    JOY = '😃',
    BLUSH = '😊',
    SURPRISE = '😮',
    SHOCK = '😲',
    WOW_FACE = '😯',
    MIND_BLOWN = '🤯',
    ASTONISHED = '😳',
    CLAP = '👏',
    PARTY = '🎉',
    FIRE = '🔥',
    COOL = '😎',
    OK = '👌',
    EYES = '👀',
    WINK = '😉',
    TONGUE_OUT = '😜',
    SILLY = '🤪',
    COFFEE = '☕',
    TEA = '🍵',
    BEER = '🍺',
    WINE = '🍷',
    COCKTAIL = '🍸',
    BALLOON = '🎈',
    GIFT = '🎁',
    CAMERA = '📷',
    VIDEO_CAMERA = '📹',
    MUSIC = '🎵',
    HEADPHONES = '🎧',
    TV = '📺',
    BOOK = '📚',
    PEN = '🖊️',
    PAPERCLIP = '📎',
    LOCK = '🔒',
    KEY = '🔑',
    MAGNIFYING_GLASS = '🔍',
    EARTH_GLOBE = '🌍',
    MAP = '🗺️',
    SUN = '☀️',
    MOON = '🌙',
    STARS = '🌟',
    UMBRELLA = '☂️',
    RAINBOW = '🌈',
    CLOCK = '⏰',
    HOURGLASS = '⌛',
    MONEY_BAG = '💰',
    SHOPPING_CART = '🛒',
    THUMBS_UP_SIGN = '👍🏻',
    THUMBS_DOWN_SIGN = '👎🏻',
    SMILING_FACE_WITH_HALO = '😇',
    NERD_FACE = '🤓',
    ROLLING_ON_THE_FLOOR_LAUGHING = '🤣',
    UPSIDE_DOWN_FACE = '🙃',
    WAVING_HAND = '👋',
    RAISED_HAND = '✋',
    VICTORY_HAND = '✌️',
    FOLDED_HANDS = '🙏',
    PERSON_RAISING_HAND = '🙋',
    PERSON_BOWING = '🙇',
    PERSON_SHRUGGING = '🤷',
    PERSON_WALKING = '🚶',
    PERSON_RUNNING = '🏃',
    PERSON_SWIMMING = '🏊',
    PERSON_BIKING = '🚴',
    PERSON_DANCING = '💃',
    PEOPLE_HUGGING = '🤗',
    SPEECH_BUBBLE = '💬',
    THOUGHT_BUBBLE = '💭',
    BUST_IN_SILHOUETTE = '👤',
    BUSTS_IN_SILHOUETTE = '👥',
    MONKEY_FACE = '🐵',
    DOG_FACE = '🐶',
    CAT_FACE = '🐱',
    PIG_FACE = '🐷',
    COW_FACE = '🐮',
    RABBIT_FACE = '🐰',
    BEAR_FACE = '🐻',
    PANDA_FACE = '🐼',
    PENGUIN = '🐧',
    BIRD = '🐦',
    BABY_CHICK = '🐤',
    HATCHING_CHICK = '🐣',
    BUG = '🐛',
    BUTTERFLY = '🦋',
    SNAIL = '🐌',
    LADY_BEETLE = '🐞',
    SPIDER = '🕷️',
    WEB = '🕸️',
    TURTLE = '🐢',
    FISH = '🐟',
    WHALE = '🐳',
    DOLPHIN = '🐬',
    OCTOPUS = '🐙',
    CACTUS = '🌵',
    TULIP = '🌷',
    ROSE = '🌹',
    SUNFLOWER = '🌻',
    PALM_TREE = '🌴',
    EVERGREEN_TREE = '🌲',
    DECIDUOUS_TREE = '🌳',
    EGGPLANT = '🍆',
    TOMATO = '🍅',
    CARROT = '🥕',
    BROCCOLI = '🥦',
    CORN = '🌽',
    HOT_PEPPER = '🌶️',
    BREAD = '🍞',
    CHEESE = '🧀',
    HAMBURGER = '🍔',
    PIZZA = '🍕',
    TACO = '🌮',
    SUSHI = '🍣',
    CUPCAKE = '🧁',
    ICE_CREAM = '🍨',
    DONUT = '🍩',
    CAKE = '🎂',
    COOKIES = '🍪',
  }
  